import { render, staticRenderFns } from "./asset-icon.vue?vue&type=template&id=6a206efe&scoped=true"
import script from "./asset-icon.vue?vue&type=script&lang=js"
export * from "./asset-icon.vue?vue&type=script&lang=js"
import style0 from "./asset-icon.vue?vue&type=style&index=0&id=6a206efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a206efe",
  null
  
)

export default component.exports